const easings = {
    one: [0.175, 0.85, 0.42, 0.96],
    two: [0.215, 0.61, 0.355, 1.0],
    easeOutBack: [0.34, 1.56, 0.64, 1],
    heavy: [0.645, 0.045, 0.355, 1],
};

export default easings;
